import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const Post = () => {
  return (
    <div>
      <Typography variant="h4">Blog Post Title</Typography>
      <Typography variant="body1">
        This is the content of the blog post. Here you can write your thoughts and ideas!
      </Typography>
      <Button variant="contained" component={Link} to="/">
        Back to Home
      </Button>
    </div>
  );
};

export default Post;
